import { Component, OnInit ,ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { WebParameterContext } from '../../../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;
@Component({
  selector: 'app-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.scss']
})
export class QuestionnaireComponent {
  @ViewChild(IonSlides) slides:IonSlides;
  slideOpts = {
    initialSlide: 0,
    speed: 400,
    autoHeight:true
  };
  
  alllong:any;
  beginnumber:number = 1;
  liatone:Array<any>= [];
  arrList:Array<any>= [];
            
  UserID:any;
  ChineseName:any; // 名称
  Name:any; // 当前门店
  StartDate:any; // 进店时间
  StoreID:any; // 门店id

  slidesMoving:boolean;
   slidesHeight:number;
  

//   arrList=[
//     {
//       "question":[
//           {
//             "questionID":"66666666666",
//             "title":"是",
//             "ischeck":false
//           },
//           {
//           "questionID":"66666666666",
//           "title":"不是",
//           "ischeck":false
//           },
//           {
//             "questionID":"66666666666",
//             "title":"以上都是",
//             "ischeck":false
//           }
//       ],
//         "ID":"189265662565",
//         "title":"是否有宝宝"
      
//     },
//     {
//       "question":[
//         {
//           "questionID":"66666666666",
//           "title":"是",
//           "ischeck":false
//         },
//         {
//         "questionID":"66666666666",
//         "title":"不是",
//         "ischeck":false,
//         },
//         {
//           "questionID":"66666666666",
//           "title":"以上都是",
//           "ischeck":false
//         }
//       ],
//       "ID":"189265662565",
//       "title":"是否二胎"
    
//   }
// ]

 
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal
  ) { 
    activaRouter.queryParams.subscribe(queryParams => {
      this.UserID =  queryParams.UserID || null ; //用户id
      this.ChineseName= queryParams.a_ChineseName || null; // snc名字
      this.Name= queryParams.tb_Name || null // 门店名称
      if(queryParams.StartDate){
        this.StartDate =queryParams.StartDate.replace(/-/g,"/").replace("T","");
      }
      this.StoreID = queryParams.StoreID || null  // 门店id
      
  });
  }
  // 数字转换成对应的英文字母
  isAbc(num:number){
    return String.fromCharCode(64+num);
  }
  ngAfterViewInit(){
    const that =this;

   
    that.LoadData(1);
  }
  onClickSlide() {
    this.slides.getActiveIndex().then(index=>{
      console.log()
      const that = this;
      that.beginnumber = index+1;
        console.log(index);
    });
   
  }
  // 下一题处理逻辑
  onClickSlidenext(){
    const that =this;
    // that.slides.slidePrev();
    this.slides.slideTo(that.beginnumber, 500);
  }
  // 上一题逻辑
  onClickSlideprev(){
    const that =this;
    // that.slides.slidePrev();
    // //debugger;
    this.slides.getActiveIndex().then(index=>{
      index=index-1;
      this.slides.slideTo(index, 500);
    });
   
  }
  // 选中的值
  checkInput(item, event) {
    const that = this;
    item.ischeck= !item.ischeck;
  }
  LoadData(Page){
    const that=this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
     let body = new WebParameterContext();
     body.Account = that.com.GetAccount;
     body.ConfigName = "QueryTBSNCQuestionnaire";
     body.OpType = "query";
     body.ConfigType = "form";
     body.RowsPerPage = app.RowsPerPage;
     body.PageNumber = 1;
     body.Client.PageName = PageName;
     body.Client.Type="add",
     body.Client.ApiType = "Content";
     body.Client.Name = "temp_content";
     body.Client.ClientType = 2;
     body.RequestBody = JSON.stringify({"userId": that.UserID});
         that.msg.Loading("请稍后...").then(loads => {
           that.http.post(app.DEFAULTURL, body).then(data => {
             setTimeout(function(){
               loads.dismiss();
             },100);
             if (data.ResponseMessage.Success) {
               console.log(data.Status,"返回的数据")
             that.arrList= data.Status;
             that.alllong = that.arrList.length;
            
             } else {
               that.msg.Alert(data.ResponseMessage.ErrorMessage);
             }
           }).catch(err => {
             loads.dismiss();
             that.msg.Alert("网络异常，请稍后再试！");
           });
          
         });
       
 

  }
 
  EventClick(){
   const that=this;
   //debugger;
   const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    let listArray=[];
    let obj={};
    // "detailID":"a03cbb24-48b1-4a18-afdb-ad6c7488fdc9", // 没有试新增  有的话是修改  没有则不传
    debugger;
    let other:boolean=false;//判断是否选择了答案;
    that.arrList.forEach(item => {
      let objtitle={};
      let question="";  
      objtitle={
        "ID":item.ID,
        "title":item.title,
        "IsReport":item.IsReport,
        "AnswerNum":item.AnswerNum,
      }
      if(item.detailID){
        objtitle["detailID"]=item.detailID;
      }
      let num:number=0;
      item.question.forEach(element => {
        if(item.detailID){
          if(element.ischeck){
            num++;
            other=true;
            question += element.title + "/";
          }
        }else{
          if(element.ischeck){
            num++;
            other=true;
            question += element.title + "/";
          }
        }
      });
      objtitle["RightNum"]=num;
      objtitle["question"]=question.substring(0,question.length-1);
      listArray.push(objtitle);
    });
    obj["userID"]=that.UserID;
    obj["StoreID"]=that.StoreID;
     obj["questions"]=listArray;
    console.log(listArray,"选中的值");
    // return
  if(!other){//如果未选择任何答案则return;
    that.msg.Alert("请先作答问卷再提交");
    return;
  }
    body.ConfigName = "TBSNCQuestionnaireRecord";
    body.OpType = "query";
    body.ConfigType = "form";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.Type="add",
    body.Client.ApiType = "Content";
    body.Client.Name = "temp_content";
    body.Client.ClientType = 2;
    body.RequestBody = JSON.stringify(obj);
    that.msg.Confirm("确定提交问卷吗？","取消","确定").then(res=>{
      if(res){
        that.msg.Loading("请稍后...").then(loads => {
          that.http.post(app.DEFAULTURL, body).then(data => {
            setTimeout(function(){
              loads.dismiss();
            },100);
            if (data.ResponseMessage.Success) {
             that.msg.Alert("操作成功").then(res=>{
             that.com.goBack();
             });
           
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          }).catch(err => {
            loads.dismiss();
            that.msg.Alert("网络异常，请稍后再试！");
          });
         
        });
      }

    });
  }
   

}
